import type React from 'react'
import {FootnotesProvider} from '@github-ui/swp-core/components/contentful/FootnotesContext'

/**
 * The App component is used to render content which should be present on _all_ routes within this app
 */
export function App(props: {children?: React.ReactNode}) {
  return <FootnotesProvider>{props.children}</FootnotesProvider>
}
